import { Fragment } from 'react';

import OrgUnitAdminContactsLargeGrid from './OrgUnitAdminContactsLargeGrid';
import OrgUnitAdminContactsSmallGrid from './OrgUnitAdminContactsSmallGrid';

const OrgUnitAdminContactsGrid = ({ gridData, isLoading, onEditContact, onDeleteContactClicked }) => {
  return (
    <Fragment>
      {isLoading === false ?
        <div className="row">
          <div className="col-xs-12">
            <p>{gridData.length === 1 ? `${gridData.length} Entry Contact` : `${gridData.length} Entry Contacts`}</p>
          </div>
        </div>
        : <Fragment><div className="row usas-extra-top-margin usas-extra-bottom-margin"></div></Fragment>}
      <OrgUnitAdminContactsLargeGrid
        gridData={gridData}
        isLoading={isLoading}
        onEditContact={onEditContact}
        onDeleteContactClicked={gridData.length > 1 ? onDeleteContactClicked : undefined}
      />
      <OrgUnitAdminContactsSmallGrid
        gridData={gridData}
        isLoading={isLoading}
        onEditContact={onEditContact}
        onDeleteContactClicked={gridData.length > 1 ? onDeleteContactClicked : undefined}
      />
    </Fragment>
  )
};

export default OrgUnitAdminContactsGrid;